import createReducer from "../../reducers/createReducer";
import {
  VENDOR_PROFILE_LOADING,
  VENDOR_PROFILE_SUCCESS,
  VENDOR_PROFILE_ERROR,
  VENDOR_TRANSACTIONS_LOADING,
  VENDOR_TRANSACTIONS_SUCCESS,
  VENDOR_TRANSACTIONS_ERROR,
  VENDOR_OVERVIEW_LOADING,
  VENDOR_OVERVIEW_SUCCESS,
  VENDOR_OVERVIEW_ERROR,
  VENDOR_SETTLEMENTS_LOADING,
  VENDOR_SETTLEMENTS_SUCCESS,
  VENDOR_SETTLEMENTS_ERROR,
  VENDOR_QR_CODE_LOADING,
  VENDOR_QR_CODE_SUCCESS,
  VENDOR_QR_CODE_ERROR,
  UPDATE_DISCOUNT_PERCENTAGE_LOADING,
  UPDATE_DISCOUNT_PERCENTAGE_SUCCESS,
  UPDATE_DISCOUNT_PERCENTAGE_ERROR,
  DOWNLOAD_QR_CODE_LOADING,
  DOWNLOAD_QR_CODE_SUCCESS,
  DOWNLOAD_QR_CODE_ERROR,
  UPDATE_VENDOR_PROFILE_LOADING,
  UPDATE_VENDOR_PROFILE_SUCCESS,
  UPDATE_VENDOR_PROFILE_ERROR,
} from "./types";

let initialState = {
  loading: false,
  error: null,
  success: null,
  vendorProfile: null,
  vendorTransactions: {
    count: 0,
    next: null,
    previous: null,
    data: [],
  },
  vendorOverview: null,
  vendorSettlements: {
    count: 0,
    next: null,
    previous: null,
    data: [],
  },
  vendorQRCode: null,
  updateDiscountSuccess: null,
  updateDiscountError: null,
  updateVendorProfileSuccess: null,
  updateVendorProfileError: null,
};

function resolveState(state = {}, newState = {}) {
  return Object.assign({}, state, newState);
}

export const vendorDashboardReducer = createReducer(initialState, {
  [VENDOR_PROFILE_LOADING](state, action) {
    return resolveState(state, {
      loading: true,
      vendorProfile: null,
      error: null,
    });
  },
  [VENDOR_PROFILE_SUCCESS](state, action) {
    return resolveState(state, {
      loading: false,
      vendorProfile: action.payload,
      error: null,
    });
  },
  [VENDOR_PROFILE_ERROR](state, action) {
    return resolveState(state, {
      loading: false,
      vendorProfile: null,
      error: action.payload,
    });
  },
  [VENDOR_TRANSACTIONS_LOADING](state, action) {
    return resolveState(state, {
      loading: true,
      error: null,
    });
  },
  [VENDOR_TRANSACTIONS_SUCCESS](state, action) {
    return resolveState(state, {
      loading: false,
      vendorTransactions: {
        count: action.payload.count || 0,
        next: action.payload.next || null,
        previous: action.payload.previous || null,
        data: action.payload.data || [],
      },
      error: null,
    });
  },
  [VENDOR_TRANSACTIONS_ERROR](state, action) {
    return resolveState(state, {
      loading: false,
      vendorTransactions: {
        count: 0,
        next: null,
        previous: null,
        data: [],
      },
      error: action.payload,
    });
  },
  [VENDOR_OVERVIEW_LOADING](state, action) {
    return resolveState(state, {
      loading: true,
      vendorOverview: null,
      error: null,
    });
  },
  [VENDOR_OVERVIEW_SUCCESS](state, action) {
    return resolveState(state, {
      loading: false,
      vendorOverview: action.payload,
      error: null,
    });
  },
  [VENDOR_OVERVIEW_ERROR](state, action) {
    return resolveState(state, {
      loading: false,
      vendorOverview: null,
      error: action.payload,
    });
  },
  [VENDOR_SETTLEMENTS_LOADING](state, action) {
    return resolveState(state, {
      loading: true,
      vendorSettlements: {
        count: 0,
        next: null,
        previous: null,
        data: [],
      },
      error: null,
    });
  },
  [VENDOR_SETTLEMENTS_SUCCESS](state, action) {
    return resolveState(state, {
      loading: false,
      vendorSettlements: {
        count: action.payload.count || 0,
        next: action.payload.next || null,
        previous: action.payload.previous || null,
        data: action.payload.data || [],
      },
      error: null,
    });
  },
  [VENDOR_SETTLEMENTS_ERROR](state, action) {
    return resolveState(state, {
      loading: false,
      vendorSettlements: {
        count: 0,
        next: null,
        previous: null,
        data: [],
      },
      error: action.payload,
    });
  },
  [VENDOR_QR_CODE_LOADING](state, action) {
    return resolveState(state, {
      loading: true,
      vendorQRCode: null,
      error: null,
    });
  },
  [VENDOR_QR_CODE_SUCCESS](state, action) {
    return resolveState(state, {
      loading: false,
      vendorQRCode: action.payload,
      error: null,
    });
  },
  [VENDOR_QR_CODE_ERROR](state, action) {
    return resolveState(state, {
      loading: false,
      vendorQRCode: null,
      error: action.payload,
    });
  },
  [UPDATE_DISCOUNT_PERCENTAGE_LOADING](state, action) {
    return resolveState(state, {
      loading: true,
      updateDiscountSuccess: null,
      updateDiscountError: null,
    });
  },
  [UPDATE_DISCOUNT_PERCENTAGE_SUCCESS](state, action) {
    return resolveState(state, {
      loading: false,
      updateDiscountSuccess: action.payload,
      updateDiscountError: null,
    });
  },
  [UPDATE_DISCOUNT_PERCENTAGE_ERROR](state, action) {
    return resolveState(state, {
      loading: false,
      updateDiscountSuccess: null,
      updateDiscountError: action.payload,
    });
  },
  [DOWNLOAD_QR_CODE_LOADING](state, action) {
    return resolveState(state, {
      loading: true,
      error: null,
    });
  },
  [DOWNLOAD_QR_CODE_SUCCESS](state, action) {
    return resolveState(state, {
      loading: false,
      success: action.payload,
      error: null,
    });
  },
  [DOWNLOAD_QR_CODE_ERROR](state, action) {
    return resolveState(state, {
      loading: false,
      success: null,
      error: action.payload,
    });
  },
  [UPDATE_VENDOR_PROFILE_LOADING](state, action) {
    return resolveState(state, {
      loading: true,
      updateVendorProfileSuccess: null,
      updateVendorProfileError: null,
    });
  },
  [UPDATE_VENDOR_PROFILE_SUCCESS](state, action) {
    return resolveState(state, {
      loading: false,
      updateVendorProfileSuccess: action.payload,
      updateVendorProfileError: null,
      vendorProfile: action.payload, // Update vendor profile in state
    });
  },
  [UPDATE_VENDOR_PROFILE_ERROR](state, action) {
    return resolveState(state, {
      loading: false,
      updateVendorProfileSuccess: null,
      updateVendorProfileError: action.payload,
    });
  },
});

